import { createContext, useContext } from 'react';

type ModalContext = {
  currentModal: React.ReactNode;
  setCurrentModal: (modal: React.ReactNode) => void;
};

export const ModalContext = createContext<ModalContext | undefined>(undefined);

// no-op modal is used for development mode to avoid errors when the modal is not set
const NOOP_MODAL: ModalContext = {
  currentModal: null,
  setCurrentModal: () => { }
};

export function useModal(): ModalContext {
  const context = useContext(ModalContext);
  return context ?? NOOP_MODAL;
}
